import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Clock, Mail, Calendar, Key, CheckCircle, XCircle, Loader2 } from 'lucide-react';

export function PendingUsersTab({ pendingUsers, actionLoading, onApprove, onReject }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5 text-yellow-500" />
          Pending Approvals
        </CardTitle>
        <CardDescription>Users waiting for admin approval to access the app</CardDescription>
      </CardHeader>
      <CardContent>
        {pendingUsers.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <CheckCircle className="h-12 w-12 mx-auto mb-4 text-green-500/50" />
            <p>No pending approvals</p>
          </div>
        ) : (
          <div className="space-y-4">
            {pendingUsers.map((u) => (
              <div key={u.user_id} className="flex items-center justify-between p-4 border rounded-lg bg-card hover:bg-accent/50 transition-colors" data-testid={`pending-user-${u.user_id}`}>
                <div className="flex items-center gap-4">
                  <div className="h-10 w-10 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center text-white font-bold">
                    {u.name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div>
                    <p className="font-medium">{u.name}</p>
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Mail className="h-3 w-3" /> {u.email}
                    </div>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground mt-1">
                      <span className="flex items-center gap-1"><Calendar className="h-3 w-3" />{new Date(u.created_at).toLocaleDateString()}</span>
                      {u.activation_code_used && <span className="flex items-center gap-1"><Key className="h-3 w-3" />{u.activation_code_used}</span>}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Button size="sm" variant="outline" className="text-red-500 hover:text-red-600 hover:bg-red-500/10" onClick={() => onReject(u.user_id, u.name)} disabled={!!actionLoading[u.user_id]} data-testid={`reject-${u.user_id}`}>
                    {actionLoading[u.user_id] === 'reject' ? <Loader2 className="h-4 w-4 animate-spin" /> : <><XCircle className="h-4 w-4 mr-1" />Reject</>}
                  </Button>
                  <Button size="sm" className="bg-green-500 hover:bg-green-600" onClick={() => onApprove(u.user_id, u.name)} disabled={!!actionLoading[u.user_id]} data-testid={`approve-${u.user_id}`}>
                    {actionLoading[u.user_id] === 'approve' ? <Loader2 className="h-4 w-4 animate-spin" /> : <><CheckCircle className="h-4 w-4 mr-1" />Approve</>}
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
